import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export type {
  ClientOrganizationMember,
  ClientOrganizationMembers
} from '@DigitaleDoerfer/digitale-doerfer-api';

export const useGetOrganizationMembers = (organizationId: string) => {
  const api = useGrapevineOrganizationApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [API_CACHE_KEYS.ORGANIZATION_MEMBERS, organizationId],
    enabled: isAuthenticated && !!organizationId,
    queryFn: () => api.getOrganizationMembers({ organizationId })
  });
};
